import notificationModule from "./notification/notification.module";
import listTableModule from "./listTable/listTable.module";
import actionListTableModule from "./actionListTable/actionListTable.module";
import listFilterModule from "./listFilter/listFilter.module";
import mainSidenavModule from "./mainSidenav/mainSidenav.module";
import mainHeaderModule from "./mainHeader/mainHeader.module";
import sortableListModule from "./sortableList/sortableList.module";
import sortableStationsModule from "./sortableStations/sortableStations.module";
import dateFilterModule from "./dateFilter/dateFilter.module";
import autocompleteModule from "./autocomplete/autocomplete.module";
import addItemModule from "./addItem/addItem.module";
import editableAutocompleteModule from "./editableAutocomplete/editableAutocomplete.module";
import editableFieldModule from "./editableField/editableField.module";
import editableCheckboxModule from "./editableCheckbox/editableCheckbox.module";
import editableSelectModule from "./editableSelect/editableSelect.module";
import editableTimeModule from "./editableTime/editableTime.module";
import editableDateModule from "./editableDate/editableDate.module";
import pickLocationMapModule from "./pickLocationMap/pickLocationMap.module";
import editableSchedulesModule from "./editableSchedules/editableSchedules.module";
import listItemsModule from "./listItems/listItems.module";
import promotionValueModule from "./promotionValue/promotionValue.module";
import editableTextareaModule from "./editableTextarea/editableTextarea.module";
import listViewModule from "./listView/listView.module";
import notesModule from "./notes/notes.module";
import directionMapModule from "./directionMap/directionMap.module";
import locationTrackingMapModule from "./locationTrackingMap/locationTrackingMap.module";
import pickupDropoffModule from "./pickupDropoff/pickupDropoff.module";
import mainFooterModule from "./mainFooter/mainFooter.module";
import stationsTimelineModule from "./stationsTimeline/stationsTimeline.module";
import godsViewMapModule from "./godsViewMap/godsViewMap.module";
import utilizationBarModule from "./utilizationBar/utilizationBar.module";
import mapPointModule from "./mapPoint/mapPoint.module";
import pieChartModule from "./pieChart/pieChart.module";
import ticketNotificationModule from "./ticketNotification/ticketNotification.module";
import captainPlanModule from "./captainPlan/captainPlan.module";
import scheduleWeekdaysModule from "./scheduleWeekdays/scheduleWeekdays.module";
import cityCaptainAppModule from "./cityCaptainApp/cityCaptainApp.module";
import paymentMethodsModule from "./paymentMethods/paymentMethods.module";
import heatmapModule from "./heatmap/heatmap.module";
import polygonModule from "./polygon/polygon.module";
import asyncListModule from "./asyncList/asyncList.module";
import editableAsyncListModule from "./editableAsyncList/editableAsyncList.module";
import editableDocumentsModule from "./editableDocuments/editableDocuments.module";
import localeEditableFieldModule from "./localeEditableField/localeEditableField.module";
import directionWaypointsModule from "./directionWaypoints/directionWaypoints.module";
import extraInformationModule from "./extraInformation/extraInformation.module";
import optionFieldModule from "./optionField/optionField.module";
import listObjectsModule from "./listObjects/listObjects.module";
import quickviewModule from "./quickview/quickview.module";
import callModule from "./call/call.module";
import colorPickerModule from "./colorPicker/colorPicker.module";
import contractVersioningModule from "./contractVersioning/contractVersioning.module";
import stepperModule from "./stepper/stepper.module";
import editableMultipleFieldsModule from "./editableMultipleFields/editableMultipleFields.module";
import sideGridModule from "./sideGrid/sideGrid.module";
import backToTopModule from "./backToTop/backToTop.module";
import loadingSpinnerModule from "./loadingSpinner/loadingSpinner.module";
import progressIndicatorModule from "./progressIndicator/progressIndicator.module";
import dispInfoModule from "./dispInfo/dispInfo.module";
import editableImageUploaderModule from "./editableImageUploader/editableImageUploader.module";
import pricingConfigurationModule from "./pricingConfiguration/pricingConfiguration.module";
import accordionItemModule from "./accordionItem/accordionItem.module";
import accordionGroupModule from "./accordionGroup/accordionGroup.module";
import rescueReasonsModule from "./rescueReasons/rescueReasons.module";
import formStepperModule from "./formStepper/formStepper.module";
import formStepModule from "./formStep/formStep.module";
import preLockedMapModule from "./preLockedMap/preLockedMap.module";
import captainInRideControlsModule from "./captainInRideControls/captainInRideControls.module";
import editableFormControlsModule from "./editableFormControls/editableFormControls.module";
import searchableMultiSelectModule from "./searchableMultiSelect/searchableMultiSelect.module";
import cityPaymentMethodsModule from "./cityPaymentMethods/cityPaymentMethods.module";
import cityFeatureFlagsModule from "./cityFeatureFlags/cityFeatureFlags.module";
import liveEtaConfigurationModule from "./liveEtaConfiguration/liveEtaConfiguration.module";
import supplySourcePaymentMethodsModule from "./supplySourcePaymentMethods/supplySourcePaymentMethods.module";
import cityCaptainVerificationModule from "./cityCaptainVerification/cityCaptainVerification.module";
import cityInvoiceConfigurationModule from "./cityInvoiceConfiguration/cityInvoiceConfiguration.module";
import fleetAdminManagementModule from "./fleetAdminManagement/fleetAdminManagement.module";
import checkInConfigurationModule from "./checkInConfiguration/checkInConfiguration.module";
const componentsModule = angular.module("app.components", [
  notificationModule.name,
  listTableModule.name,
  listFilterModule.name,
  mainSidenavModule.name,
  mainHeaderModule.name,
  sortableListModule.name,
  sortableStationsModule.name,
  dateFilterModule.name,
  autocompleteModule.name,
  addItemModule.name,
  editableAutocompleteModule.name,
  editableFieldModule.name,
  editableCheckboxModule.name,
  editableSelectModule.name,
  editableTimeModule.name,
  editableDateModule.name,
  pickLocationMapModule.name,
  editableSchedulesModule.name,
  listItemsModule.name,
  promotionValueModule.name,
  editableTextareaModule.name,
  listViewModule.name,
  notesModule.name,
  actionListTableModule.name,
  directionMapModule.name,
  locationTrackingMapModule.name,
  pickupDropoffModule.name,
  mainFooterModule.name,
  stationsTimelineModule.name,
  godsViewMapModule.name,
  utilizationBarModule.name,
  mapPointModule.name,
  pieChartModule.name,
  ticketNotificationModule.name,
  captainPlanModule.name,
  scheduleWeekdaysModule.name,
  cityCaptainAppModule.name,
  paymentMethodsModule.name,
  heatmapModule.name,
  polygonModule.name,
  asyncListModule.name,
  editableAsyncListModule.name,
  editableDocumentsModule.name,
  localeEditableFieldModule.name,
  directionWaypointsModule.name,
  extraInformationModule.name,
  optionFieldModule.name,
  listObjectsModule.name,
  quickviewModule.name,
  callModule.name,
  colorPickerModule.name,
  contractVersioningModule.name,
  stepperModule.name,
  editableMultipleFieldsModule.name,
  sideGridModule.name,
  backToTopModule.name,
  loadingSpinnerModule.name,
  dispInfoModule.name,
  editableImageUploaderModule.name,
  progressIndicatorModule.name,
  pricingConfigurationModule.name,
  accordionItemModule.name,
  accordionGroupModule.name,
  rescueReasonsModule.name,
  pricingConfigurationModule.name,
  formStepperModule.name,
  formStepModule.name,
  preLockedMapModule.name,
  captainInRideControlsModule.name,
  editableFormControlsModule.name,
  searchableMultiSelectModule.name,
  cityPaymentMethodsModule.name,
  cityFeatureFlagsModule.name,
  liveEtaConfigurationModule.name,
  supplySourcePaymentMethodsModule.name,
  cityCaptainVerificationModule.name,
  cityInvoiceConfigurationModule.name,
  fleetAdminManagementModule.name,
  checkInConfigurationModule.name,
]);

export default componentsModule;



// WEBPACK FOOTER //
// ./src/components/index.js